<template>
  <section :class="bindSectionClass" :style="cigPriceColor">
    <SvgIcon
      class="svg-icon top"
      :style="svgIconColor"
      name="cheek"
      scale="20"
    />
    <div class="desktop-submitn-content">
      <!-- 标题 -->
      <div class="title-content">
        <p class="title">
          {{ $t('publicDetails.pc_settlement_title') }}
        </p>
        <MBIcon
          @click="handleCloseWrapper"
          name="icon-close"
          class="icon-close"
          size="24"
          :color="iconColor"
        />
      </div>
      <!-- SKU信息 -->
      <div class="sku-info" :style="skuBackColor">
        <div class="lt">
          <p class="info">{{ getSkuName.name }}</p>
          <p class="desc" v-show="getSkuName.subName">
            +{{ getSkuName.subName?.trim() }}
          </p>
        </div>
        <div class="rt">
          <img v-lazy="skuIcon" alt="sku logo" />
        </div>
      </div>
      <!-- 官方价格【SKU价格】 -->
      <div class="info-item authority" @click="handleDropdown">
        <div class="lt">{{ text.originalPriceText }}</div>
        <div class="rt">
          <GeneralPrice
            :injectColor="mFontColor.color"
            :className="'scribing'"
            :price="hackOriginalPrice"
            :isRenderKB="true"
          />
          <div
            :class="['drop-down', !small600 ? 'pack-up' : '']"
            :style="{ borderTopColor: iconColor }"
          ></div>
        </div>
      </div>
      <!-- 支付通道 -->
      <div :class="['info-item', small600 ? 'hide-dom' : '']">
        <div class="lt">
          <img
            v-show="payIcon"
            v-lazy="payIcon"
            alt="payment logo"
            class="payment-logo"
          />
        </div>
        <div class="rt">
          <div v-show="payStatus !== 'pending'">
            <GeneralPrice
              :injectColor="mFontColor.color"
              :className="'scribing'"
              :price="payChannelprice"
              :isRenderKB="true"
              prefix="-"
            />
          </div>

          <van-loading
            v-show="payStatus == 'pending'"
            size="22"
            type="spinner"
            class="loading-icon"
          />
        </div>
      </div>
      <!-- 优惠券价格 -->
      <div :class="['info-item', 'coupon-item', small600 ? 'hide-dom' : '']">
        <div class="lt">
          <MBIcon
            defaultClass="colour"
            name="c-coupon-yellow"
            class="icon"
            :size="iconSize"
          />
        </div>
        <div class="rt">
          <van-loading
            v-show="toggleCouponLoging"
            type="spinner"
            class="loading-icon"
          />
          <GeneralPrice
            :injectColor="mFontColor.color"
            v-show="!toggleCouponLoging"
            :className="'scribing'"
            :price="couponDiscountMoney"
            :isRenderKB="true"
            prefix="-"
          />
        </div>
      </div>

      <!-- 总价格 -->
      <div class="info-item last">
        <div class="lt">{{ $t('common.payPricePrefix') }}</div>
        <div class="rt">
          <MyPriceTaxRate
            :injectColor="mFontColor.color"
            :isBeat="true"
            :price="hackFinalPrice"
          />
        </div>
      </div>
      <slot> </slot>
    </div>

    <SvgIcon
      class="svg-icon bottom"
      :style="svgIconColor"
      name="cheek"
      scale="20"
    />
  </section>
</template>

<script>
  import MyPriceTaxRate from '@page_detail/components/MyPriceTaxRate'
  import GeneralPrice from '@/components/GeneralPrice'
  import SvgIcon from 'vue-svg-icon/Icon.vue'
  import MBIcon from '@/components/MBIcon'
  import isEmpty from 'lodash/isEmpty'
  import calculatePrice from '@/mixins/detail/calculatePrice'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { isJsonString } from '@/utils/tool'
  import { mapState, mapMutations, mapGetters } from 'vuex'
  import { hexToRgba } from '@/utils/hexToRgba'

  export default {
    name: 'new-desktop-submitn', // pc端游戏详情页
    mixins: [calculatePrice, styleConfiguration],
    components: {
      MBIcon,
      SvgIcon,
      GeneralPrice,
      MyPriceTaxRate,
    },
    data() {
      return {
        small600: true,
      }
    },
    computed: {
      ...mapGetters(['isEuropeCountry', 'isGenshinEn']),
      ...mapState(['isDesktop']),
      ...mapState('detail', ['toggleCouponLoging', 'payStatus']),

      bindSectionClass() {
        const cls = ['desktop-submitn']
        if (this.small600) {
          cls.push('min-height')
        }
        if (!this.isEuropeCountry) {
          cls.push('fault-europe')
        }
        return cls
      },
      iconColor() {
        return hexToRgba(this.mFontColor.color, 0.6)
      },
      iconSize() {
        if (this.isDesktop) return 24
        return 30
      },
      cigPriceColor() {
        return {
          '--priceColor': this.mFontColor?.color || '#fff9e2',
          '--moduleColor': this.pcModuleBackColor?.backgroundColor || '#000',
          '--borderColor':
            hexToRgba(this.mFontColor.color, 0.05) || 'hsla(0, 0%, 100%, .05)',
        }
      },
      getSkuName() {
        const { skuName = '' } = this.selectSkuItem || {}
        if (skuName && skuName.indexOf('+') > -1) {
          return {
            name: skuName.split('+')[0],
            subName: skuName.split('+')[1],
          }
        }
        return { name: skuName, subName: '' }
      },
      payIcon() {
        if (isEmpty(this.selectChannelItem)) return ''
        return this.selectChannelItem.logo
      },
      text() {
        let submitText = ''
        const cgames = ['soul-land3d', 'genshin-en', 'shining-nikki']

        if (cgames.includes(this.gameName)) {
          submitText = this.$t(`${this.gameName}.submit_btn_text`)
        } else {
          submitText = this.$t('order.continue_to_pay')
        }

        return {
          originalPriceText: this.$t('common.originalPriceText'),
          payPricePrefix: this.$t('common.payPricePrefix'),
          submitText,
        }
      },

      svgIconColor() {
        let color = this.pcModuleBackColor.backgroundColor
        return `color:${color}`
      },
      skuIcon() {
        if (isEmpty(this.selectSkuItem)) return ''
        // 兼容外部的SKU
        const { skuExtraInfo = '' } = this.selectSkuItem
        if (skuExtraInfo && isJsonString(skuExtraInfo)) {
          return JSON.parse(skuExtraInfo).background_url || ''
        }
        return ''
      },
    },
    methods: {
      ...mapMutations(['detail/setRenderPcNav']),
      handleCloseWrapper() {
        this['detail/setRenderPcNav'](false)
      },
      handleDropdown() {
        this.small600 = !this.small600
      },
    },
  }
</script>

<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './styles_pc.scss';
  }
  @media (max-width: 900px) {
    @import './900.scss';
  }
  @media (max-height: 600px) {
    @import './600.scss';
  }
</style>
